import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderSlot as _renderSlot, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "io-modal__loader"
}
const _hoisted_2 = {
  key: 1,
  class: "io-modal__heading"
}
const _hoisted_3 = { class: "row g-0" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = {
  key: 0,
  class: "col-auto position-relative"
}

import {
  ref,
  computed,
} from 'vue';
import ClickWrapper from '@/components/ClickWrapper.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSpinner, faTimes } from '@fortawesome/pro-light-svg-icons';


export default /*#__PURE__*/_defineComponent({
  props: {
  headline: {
    type: String,
    default: null,
  },
  closeable: {
    type: Boolean,
    default: true,
  },
  small: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
},
  emits: ['close'],
  setup(__props, { expose, emit }) {

const props = __props

library.add(faSpinner);
library.add(faTimes);





const show = ref(false);
const fadeIn = ref(false);
const fadeOut = ref(false);

const classes = computed(() => ({
  'io-modal': true,
  open: fadeIn.value || show.value || fadeOut.value,
  shown: show.value,
  small: props.small,
}));

const open = () => {
  fadeIn.value = true;
  setTimeout(() => {
    show.value = true;
  }, 25);
  setTimeout(() => {
    fadeIn.value = false;
  }, 680);
};

const close = () => {
  fadeOut.value = true;
  show.value = false;
  setTimeout(() => {
    fadeOut.value = false;
  }, 680);

  if (props.closeable) {
    emit('close');
  }
};

const onClickOutside = () => {
  if (props.closeable) {
    close();
  }
};

expose({
  open,
  close,
});

return (_ctx: any,_cache: any) => {
  const _component_IoHeadline = _resolveComponent("IoHeadline")!
  const _component_IoCard = _resolveComponent("IoCard")!

  return (show.value || fadeOut.value || fadeIn.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([_unref(classes), "d-print-none"])
      }, [
        _createVNode(ClickWrapper, {
          class: "io-modal__container",
          ref: (_value, _refs) => {
            _refs['root'] = _value
          },
          onOutside: onClickOutside
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IoCard, { "text-align": "start" }, {
              prebody: _withCtx(() => [
                (__props.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _createElementVNode("div", null, [
                        _createVNode(_unref(FontAwesomeIcon), {
                          icon: "fa-light fa-spinner",
                          class: "fa-pulse"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (__props.headline)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_IoHeadline, {
                            "text-align": "start",
                            size: "h6",
                            innerHTML: __props.headline
                          }, null, 8, ["innerHTML"])
                        ]),
                        (__props.closeable)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createElementVNode("button", {
                                class: "close font-h4",
                                onClick: close
                              }, [
                                _createVNode(_unref(FontAwesomeIcon), { icon: "fa-light fa-times" })
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                (!__props.headline)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "close close-absolute font-h4",
                      onClick: close
                    }, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: "fa-light fa-times" })
                    ]))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            })
          ]),
          _: 3
        }, 512)
      ], 2))
    : _createCommentVNode("", true)
}
}

})